import { css } from '@emotion/core';
import { variables, rgba } from '@domain-group/fe-brary';
var font = variables.font,
  colour = variables.colour,
  global = variables.global;
export var container = /*#__PURE__*/css("padding:0 10px;height:15px;z-index:", global.layerOverlay, ";color:", colour.neutral700, ";background-color:", rgba(colour.neutral50, 0.9), ";");
export var text = /*#__PURE__*/css("font-family:", font.bodyFontFamily, ";font-size:12px;line-height:15px;");